import { PermissionCheck } from "@/src/components/permissions/PermissionCheck";
import { Ddql, PermissionsResourceType } from "@/src/graphql/generated";
import { links } from "@/src/utils/links";
import { truncateText } from "@/src/utils/truncateText";
import { MessageCircleQuestionIcon } from "lucide-react";
import { NavLink, useParams } from "react-router-dom";

export function DdqlPill(props: { ddql: Pick<Ddql, "id" | "name"> }) {
  const { ddql } = props;
  const { dealId } = useParams<{ dealId: string }>();
  return (
    <PermissionCheck
      input={{
        permissionKey: "questions:view",
        resource: {
          resourceID: ddql.id,
          resourceType: PermissionsResourceType.Ddql,
        },
      }}
    >
      <NavLink
        to={links.ddqlLink(ddql, dealId)}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="rounded-full bg-blue-100 hover:bg-blue-200 text-blue-700 px-2 py-1 text-xs flex items-center gap-x-1">
          <MessageCircleQuestionIcon className="w-4 h-4" />
          {truncateText(ddql.name, 30)}
        </div>
      </NavLink>
    </PermissionCheck>
  );
}
